import { useLanguage } from "@/contexts/LanguageContext";
import Logo from "@/components/Logo";
import { Instagram, Facebook, Youtube, ExternalLink, Users, Church, Heart } from "lucide-react";

const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary text-foreground py-12">
      <div className="container mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div id="organization">
            <h3 className="font-heading font-bold mb-4 text-lg">
              Organizatorzy
            </h3>
            <div className="space-y-4 text-sm">
              <div className="flex items-start gap-2">
                <Heart className="h-4 w-4 flex-shrink-0 mt-1 text-muted-foreground" />
                <a
                  href="https://angelsofeastafrica.org"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-muted-foreground hover:text-primary transition-colors group"
                >
                  {t("footer.organizations")}
                  <ExternalLink className="inline-block ml-1 h-3 w-3 opacity-0 group-hover:opacity-100 transition-opacity" />
                </a>
              </div>
              <div className="flex items-start gap-2">
                <Church className="h-4 w-4 flex-shrink-0 mt-1 text-muted-foreground" />
                <a
                  href="https://arka.org.pl"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-muted-foreground hover:text-primary transition-colors group"
                >
                  {t("footer.church")}
                  <ExternalLink className="inline-block ml-1 h-3 w-3 opacity-0 group-hover:opacity-100 transition-opacity" />
                </a>
              </div>
              <div className="flex items-start gap-2">
                <Users className="h-4 w-4 flex-shrink-0 mt-1 text-muted-foreground" />
                <a
                  href="/partners"
                  className="text-muted-foreground hover:text-primary transition-colors"
                >
                  i inne kościoły
                </a>
              </div>
            </div>
            <div className="flex space-x-4 mt-8">
              <a
                href="https://www.facebook.com/arka.poznan"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="text-muted-foreground hover:text-primary transition-colors"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a
                href="https://www.instagram.com/kosciol.arka/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="text-muted-foreground hover:text-primary transition-colors"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a
                href="https://www.youtube.com/@arkacentrum/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
                className="text-muted-foreground hover:text-primary transition-colors"
              >
                <Youtube className="h-5 w-5" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-heading font-bold mb-4 text-lg">
              {t("footer.quicklinks")}
            </h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="/"
                  className="text-sm hover:text-primary transition-colors"
                >
                  {t("nav.home")}
                </a>
              </li>
              <li>
                <a
                  href="/about"
                  className="text-sm hover:text-primary transition-colors"
                >
                  {t("nav.about")}
                </a>
              </li>
              <li>
                <a
                  href="/events"
                  className="text-sm hover:text-primary transition-colors"
                >
                  {t("nav.events")}
                </a>
              </li>
              <li>
                <a
                  href="/contact"
                  className="text-sm hover:text-primary transition-colors"
                >
                  {t("nav.contact")}
                </a>
              </li>
              <li>
                <a
                  href="https://biznes.kaznodziejazkarabinem.pl"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm hover:text-primary transition-colors flex items-center"
                >
                  {t("nav.business")} <ExternalLink className="ml-1 h-3 w-3" />
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading font-bold mb-4 text-lg">
              {t("footer.contact")}
            </h3>
            <address className="not-italic text-sm space-y-2 text-muted-foreground">
              <p>{t("contact.coordinator")}</p>
              <p>email: marta@arka.org.pl</p>
            </address>
            <a
              href="https://machinegunpreacher.org"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center mt-4 text-sm hover:text-primary transition-colors"
            >
              {t("footer.mgp")} <ExternalLink className="ml-1 h-3 w-3" />
            </a>
          </div>
        </div>

        <div className="border-t border-border pt-8 text-sm text-center text-muted-foreground">
          <p>
            &copy; {currentYear} kaznodziejazkarabinem.pl - {t("footer.rights")}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
